import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "icon", "iconColor", "accessibilityLabel"];
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Bullet } from '@mediahuis/chameleon-theme-wl/icons';
import Icon from '../../Icon';
import Screenreader from '../../Screenreader';
import system from '../../../system';
import styles from '../index.module.scss';
var SYSTEM_PROPS = []; // No system props allowed

var ListItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      icon = _ref.icon,
      iconColor = _ref.iconColor,
      accessibilityLabel = _ref.accessibilityLabel,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _system = system(props, SYSTEM_PROPS),
      className = _system[0],
      style = _system[1],
      rest = _system[2];

  return /*#__PURE__*/React.createElement("li", _extends({}, rest, {
    ref: ref,
    className: cx(styles.listItemRoot, icon && styles.customIcon, className),
    style: style
  }), /*#__PURE__*/React.createElement(Icon, {
    "aria-hidden": "true",
    as: icon || Bullet,
    color: iconColor,
    className: styles.icon
  }), accessibilityLabel && /*#__PURE__*/React.createElement(Screenreader, null, accessibilityLabel, " "), children);
});
ListItem.displayName = 'ListItem';
ListItem.identifier = ListItem.displayName;
ListItem.clonableProps = SYSTEM_PROPS;
ListItem.defaultProps = {
  accessibilityLabel: ''
};
export default ListItem;